"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappSubmissionData = void 0;
exports.addDefaultStepCreator = addDefaultStepCreator;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
var _SubmissionStepFactory = require("./SubmissionStepFactory");
var _data = require("../data");
const defaultStepFactory = new _SubmissionStepFactory.SubmissionStepFactory();
function addDefaultStepCreator(executor, creator) {
  defaultStepFactory.addType(executor, creator);
}
class DumbappSubmissionData {
  constructor(data) {
    (0, _defineProperty2.default)(this, "args", void 0);
    (0, _defineProperty2.default)(this, "created", void 0);
    (0, _defineProperty2.default)(this, "executor", void 0);
    (0, _defineProperty2.default)(this, "extras", void 0);
    (0, _defineProperty2.default)(this, "from", void 0);
    (0, _defineProperty2.default)(this, "id", void 0);
    (0, _defineProperty2.default)(this, "inputs", void 0);
    (0, _defineProperty2.default)(this, "meta", void 0);
    (0, _defineProperty2.default)(this, "shortcode", void 0);
    (0, _defineProperty2.default)(this, "input", void 0);
    (0, _defineProperty2.default)(this, "query", void 0);
    (0, _defineProperty2.default)(this, "steps", void 0);
    (0, _defineProperty2.default)(this, "approval", void 0);
    Object.assign(this, (0, _remeda.omit)(data, ["steps"]));
    this.steps = data.steps.map((it, index) => defaultStepFactory.create(data.executor, it, index));
  }
  completed() {
    return !this.steps.find(it => !it.completed());
  }
  completedTime() {
    let step = this.steps[this.steps.length - 1];
    if (step.status === "completed") {
      return step.ended;
    }
    return null;
  }
  pending() {
    return !!this.steps.find(it => it.pending());
  }
  pendingStep() {
    return this.steps.find(it => it.pending());
  }
  error() {
    let tx = this.steps.find(it => !!it.error);
    if (tx) {
      return tx.error;
    }
    return null;
  }
  errorIndex() {
    return this.steps.findIndex(it => !!it.error);
  }
  pendingConfirmation() {
    return !!this.steps.find(it => it.pendingConfirmation());
  }
  status() {
    let pending = this.steps.find(it => it.pending());
    if (pending) {
      return pending.status;
    }
    let last = this.steps[this.steps.length - 1];
    return (last === null || last === void 0 ? void 0 : last.status) || "unknown";
  }
  getInput(name) {
    for (let input of this.inputs) {
      if (input.data[name]) {
        switch (input.type) {
          case "form":
            return (0, _data.formDataToValue)(input.data[name]);
          default:
            return input.data[name];
        }
      }
    }
    return null;
  }
  toString() {
    return this.status();
  }
}
exports.DumbappSubmissionData = DumbappSubmissionData;
//# sourceMappingURL=DumbappSubmissionData.js.map